import React, { lazy,Suspense } from 'react'

import { getCurrencyByLocale } from 'utils/currencyHelper'
import { NON_ARABIC_DOMAINS } from 'constants/base'
import { getCookie, setCookie } from 'utils/browserHelper'

import { DOMAIN } from 'constants/base'
import { DOMAIN_COUNTRY_MAP } from 'constants/flightResults'
//import HomePage from './homePage'
import HomePageNew from './homePageNew'
const HomePage = lazy(() => import(/* webpackChunkName: "homePageMe" */ './homePage'))
function Home(props) {
    const { hasError = false, initialTS = new Date().getTime(), resetInitialTime } = props || {}
    const { locale } = getCurrencyByLocale()
    const oldHomePage = DOMAIN_COUNTRY_MAP[DOMAIN] !== 'IN'

    if (
        !NON_ARABIC_DOMAINS.includes(locale) &&
        window.location.pathname.indexOf('/ar') !== -1 &&
        getCookie('lp') !== 'ar'
    ) {
        setCookie('lp', 'ar')
    }
    if (oldHomePage) {
        return (
        <Suspense fallback={<></>}>
            <HomePage hasError={hasError} initialTS={initialTS} resetInitialTime={resetInitialTime} />
        </Suspense>
        )
        
    } else {
        return <HomePageNew hasError={hasError} initialTS={initialTS} resetInitialTime={resetInitialTime} />
    }
}

// TODO Spelling mistake correction
class HomeWithErrorBounday extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            hasError: false,
            initialTS: new Date().getTime()
        }
    }

    static getDerivedStateFromError(error) {
        // TODO: ScrollToTop issue was there in qa/prod, due to node modules. So need to handle those error explicitely
        return { hasError: true }
    }

    resetInitialTime = () => {
        this.setState({
            initialTS: new Date().getTime()
        })
    }

    componentDidCatch(error, info) {
       if (typeof newrelic == 'object') {
            newrelic.addPageAction('desktop-error', {
                result: 'error',
                errorStack: error.stack,
                component: 'HomePage',
                errorInfo: info
            })
        }
    }

    render() {
        const { hasError, initialTS } = this.state || {}
        return (
            <>
                <Home hasError={hasError} initialTS={initialTS} resetInitialTime={this.resetInitialTime} />
            </>
        )
    }
}

export default HomeWithErrorBounday
